export const toSafeUploadFileName = (fileName: string): string => {
  const lastDot = fileName.lastIndexOf(".")
  const hasExtension = lastDot > 0 && lastDot < fileName.length - 1
  const base = hasExtension ? fileName.slice(0, lastDot) : fileName
  const extension = hasExtension ? fileName.slice(lastDot) : ""

  const safeBase = base
    .replace(/[^A-Za-z0-9._-]+/g, "_")
    .replace(/^_+|_+$/g, "")

  return `${safeBase || "file"}${extension}`
}
